var init, deviceStr;
var OFFSET_SCROLL = 0;
$(window).bind("load", function () {
    init();
});
(function($) {
	$(function(){

        /**
         * body固定・解除
         * fixedBody
         * 
         * @param  {Boolean} sw trueで固定
         * @return {--}    
         * 
         */
        //IEですか？
        var ua, isIE, array, version;
        ua = window.navigator.userAgent.toLowerCase();
        isIE = (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0);
        if (isIE) {
            array = /(msie|rv:?)\s?([\d\.]+)/.exec(ua);
            version = (array) ? array[2] : '';
        }

        var scrollTop;
        var scrollBarWidth = window.innerWidth - $(window).width();
        if (deviceStr != "pc") {
            scrollBarWidth = 0;
        }

        fixedBody = function (sw, forced) {
            if (sw) {
                scrollTop = $(window).scrollTop();
                if (forced) {
                    scrollTop = 0;
                }
                if ($(window).width() > 640) {
                    // if (deviceStr == 'pc') {
                    $('body').addClass('noscroll').css('top', (-scrollTop) + 'px');
                }
                $('body').css('top', (-scrollTop) + 'px');
                $('body').addClass('fixed');
                $('body').css({
                    width: 'calc(100% - ' + scrollBarWidth + 'px)'
                });
                $('.nav-supli').css({
                    width: 'calc(100% - ' + scrollBarWidth + 'px)'
                });
                $('html').css('overflow', 'hidden');
            } else {
                // IE11対策
                var offsetTime = 0;
                if (isIE && Number(version) == 11) {
                    offsetTime = 1;
                    setTimeout(function () {
                        $('body').removeClass('noscroll');
                        $(window).scrollTop(scrollTop);
                        $('body').removeClass('fixed');
                        
                    }, offsetTime);
                    $('body').css({
                        top: '',
                        width: ''
                    });
                } else {
                    $('body').removeClass('noscroll');
                    $('body').removeClass('fixed');
                    $('body').css({
                        top: '',
                        width: ''
                    });
                    $(window).scrollTop(scrollTop);
                    
                }
                $('.nav-supli').css({
                    width: ''
                });
                $('html').css('overflow', '');

            }
        }
        $('.nav__global .nav__inner a').click(function () {
            $('.nav__global').removeClass('open');
            fixedBody(false);
            $('.nav__global .nav__inner').fadeOut(400, function () {
            });
        })
        $('.nav__global .button__nav').click(function (event) {
            if ($('.nav__global').hasClass('open')) {
                $('.nav__global').removeClass('open');
                fixedBody(false);
                $('.nav__global .nav__inner').fadeOut(400, function () {
                });
            }else{
                $('.nav__global').addClass('open');
                fixedBody(true);
                $('.nav__global .nav__inner').fadeIn(400, function () {
    
                });
            }
            return false;
        })


		 init = function () {
			$('a[href^="#"]').click(function(){
				var speed = 500;
				var href= $(this).attr("href");
                if (href.length <= 1) {
                    return;
                }
				var target = $(href == "#" || href == "" ? 'html' : href);
				var position = target.offset().top + OFFSET_SCROLL;
                setTimeout(function () {
                    
                    $("html, body").animate({scrollTop:position}, speed, "swing");
                },10)
				return false;
			});	
			if (location.hash) {
				$("html, body").animate({scrollTop:$(location.hash).offset().top + OFFSET_SCROLL}, 500, "swing");
			};
		}	
	});
})(jQuery);

